import { loadScript } from '../shared/dom'

const RECAPTCHA_URL = 'https://www.google.com/recaptcha/enterprise.js'

export async function executeRecaptcha(
  { siteKey, action }: { siteKey: string; action: string },
  { hideBadge }: { hideBadge: boolean },
): Promise<string> {
  if (hideBadge) {
    hideRecaptchaBadge()
  }

  if (!window.grecaptcha?.enterprise) {
    await loadScript(`${RECAPTCHA_URL}?render=${siteKey}`)
  }

  return new Promise((resolve, reject) => {
    window.grecaptcha.enterprise.ready(() => {
      window.grecaptcha.enterprise.execute(siteKey, { action }).then(resolve, reject)
    })
  })
}

function hideRecaptchaBadge(): void {
  const RECAPTCHA_BADGE_STYLE_ID = `${RUNTIME_KEY || 'w'}-hide-grecaptcha-badge`
  const found = document.querySelector(`#${RECAPTCHA_BADGE_STYLE_ID}`)
  if (!found) {
    document.head.insertAdjacentHTML(
      'beforeend',
      `<style id="${RECAPTCHA_BADGE_STYLE_ID}">.grecaptcha-badge { visibility: hidden; }</style>`,
    )
  }
}
